import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a98de830"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "modal-card" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: null }, "None", -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "article" }, "Article", -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "profile" }, "Profile", -1));
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { key: 1 };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "" }, "Select one", -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "male" }, "Male", -1));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "female" }, "Female", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_o_input = _resolveComponent("o-input");
    const _component_o_field = _resolveComponent("o-field");
    const _component_explore_btn = _resolveComponent("explore-btn");
    const _component_o_select = _resolveComponent("o-select");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_o_field, { label: "OG Title" }, {
            default: _withCtx(() => [
                _createVNode(_component_o_input, {
                    type: "text",
                    modelValue: $setup.model.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.model.title) = $event))
                }, null, 8, ["modelValue"])
            ]),
            _: 1
        }),
        _createVNode(_component_o_field, { label: "OG Description" }, {
            default: _withCtx(() => [
                _createVNode(_component_o_input, {
                    type: "text",
                    modelValue: $setup.model.description,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($setup.model.description) = $event))
                }, null, 8, ["modelValue"])
            ]),
            _: 1
        }),
        _createElementVNode("div", null, [
            _createVNode(_component_o_field, { label: "OG Image Filename" }, {
                default: _withCtx(() => [
                    _createVNode(_component_o_input, {
                        type: "text",
                        disabled: $setup.wasImageSelected,
                        modelValue: $setup.model.image.url,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($setup.model.image.url) = $event))
                    }, null, 8, ["disabled", "modelValue"])
                ]),
                _: 1
            }),
            _createVNode(_component_explore_btn, { onInput: $setup.SelectImage }, {
                default: _withCtx(() => [
                    _createTextVNode("Choose an image")
                ]),
                _: 1
            }, 8, ["onInput"])
        ]),
        _createVNode(_component_o_field, { label: "OG Type" }, {
            default: _withCtx(() => [
                _createVNode(_component_o_select, {
                    modelValue: $setup.model.type,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($setup.model.type) = $event))
                }, {
                    default: _withCtx(() => [
                        _hoisted_2,
                        _hoisted_3,
                        _hoisted_4
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]),
            _: 1
        }),
        ($setup.model.type === 'article')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_o_field, { label: "Article Author" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_o_input, {
                            type: "text",
                            modelValue: $setup.model.article.author,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (($setup.model.article.author) = $event))
                        }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                })
            ]))
            : _createCommentVNode("", true),
        ($setup.model.type === 'profile')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_o_field, { label: "Profile First Name" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_o_input, {
                            type: "text",
                            modelValue: $setup.model.profile.first_name,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (($setup.model.profile.first_name) = $event))
                        }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                }),
                _createVNode(_component_o_field, { label: "Profile Last Name" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_o_input, {
                            type: "text",
                            modelValue: $setup.model.profile.last_name,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (($setup.model.profile.last_name) = $event))
                        }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                }),
                _createVNode(_component_o_field, { label: "Profile Username" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_o_input, {
                            type: "text",
                            modelValue: $setup.model.profile.username,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => (($setup.model.profile.username) = $event))
                        }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                }),
                _createVNode(_component_o_field, { label: "Profile Gender" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_o_select, {
                            modelValue: $setup.model.profile.gender,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => (($setup.model.profile.gender) = $event))
                        }, {
                            default: _withCtx(() => [
                                _hoisted_7,
                                _hoisted_8,
                                _hoisted_9
                            ]),
                            _: 1
                        }, 8, ["modelValue"])
                    ]),
                    _: 1
                })
            ]))
            : _createCommentVNode("", true)
    ]));
}
